import ReferralDetailContainer from './ReferralDetailContainer';

export default ReferralDetailContainer;
